import React, { useState, useEffect } from "react";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import loader from "../../assets/Images/loader.gif";
import imageCompression from 'browser-image-compression';
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

const optionCustomerContacted = [
  { value: "", label: "Select Status" },
  { value: "True", label: "Yes" },
  { value: "False", label: "No" },
];

const MaterialConsumeNext = () => {
  const style = {
    control: (base) => ({
      ...base,
      border: 0,
      // Remove box shadow
      boxShadow: "none",
      backgroundColor: "transparent",
      color: "black",
    }),
    inputFocused: {
      boxShadow: "none",
      fontSize: "14px",
    },
  };
  const [nrgPinNo, setNrgPinNo] = useState("");
 
  const [showWHModal, setShowWHModal] = useState(false);
  const [warehouseNumber, setWarehouseNumber] = useState("");
  const [loading, setLoading] = useState(false);
  const [activeForm, setActiveForm] = useState("form1");
  const [resolutionCodeOne, setResolutionCodeOne] = useState([]);
  const [optionResolutionCodeOne,setOptionResolutionCodeOne]=useState([]);
  const [resolutionCodeTwo, setResolutionCodeTwo] = useState("");
  const [optionResolutionCodeTwo,setOptionResolutionCodeTwo]=useState([]);
  const [resolutionCodeThree, setResolutionCodeThree] = useState("");
  const [optionResolutionCodeThree,setOptionResolutionCodeThree]=useState([]);
  const [customerContacted, setCustomerContacted] = useState(optionCustomerContacted[0]);
  const [fileName, setFileName] = useState("");
  const [fileNameMl, setFileNameMl] = useState("");
  const [fileNameLan, setFileNameLan] = useState("");
  const [fileNameRouter, setFileNameRouter] = useState("");
  const [customerFAQ, setCustomerFAQ] = useState("");
  const [base64ContentWifi, setBase64ContentWifi] = useState("");
  const [fileExtensionWifi, setFileExtensionWifi] = useState("");
  const [base64ContentMl, setBase64ContentMl] = useState("");
  const [fileExtensionMl, setFileExtensionMl] = useState("");
  const [base64ContentRouter, setBase64ContentRouter] = useState("");
  const [fileExtensionRouter, setFileExtensionRouter] = useState("");
  const [base64ContentLan, setBase64ContentLan] = useState("");
  const [fileExtensionLan, setFileExtensionLan] = useState("");
  const [currentSessionStatus,setCurrentSessionStatus]=useState("");
  const [position, setPosition] = useState({ latitude: null, longitude: null });
  const [doaFlag, setDoaFlag] = useState(false);
  const [userData, setuserData] = useState({
    rfo: "",
  });

  const handleChange = (e) => {
    // console.log(e.target.name, e.target.value);
    setuserData({ ...userData, [e.target.name]: e.target.value });
  };


  useEffect(() => {
    const callApprovalAPI = async () => {
      try {
        const apiUrl = process.env.REACT_APP_API_URL;
        const requestData = {
          Action: "getsubmitApprovalERP",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          srNumber: sessionStorage.getItem("ViewSR"),
          // "srNumber": "SR24042534758",
          password: sessionStorage.getItem("password"),
          userName: sessionStorage.getItem("userName"),
        };
 
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(requestData),
        });
 
        const result = await response.json();
        // console.log("Approval API result:", result);
 
        // If the API returns a DOA flag of "true", update state
        if (
          result.Status === "Success" &&
          result.Response &&
          result.Response.DoaFlag === "true"
        ) {
          setDoaFlag(true);
        }
      } catch (error) {
        console.error("Error calling approval API:", error);
        toast.error("Error calling approval API", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
      }
    };
 
    callApprovalAPI();
  }, []);


  const handleSubmitApproval = async () => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const requestData = {
        Action: "submitForApprovalERP",
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        srNumber: sessionStorage.getItem("ViewSR"),
        password: sessionStorage.getItem("password"),
        userName: sessionStorage.getItem("userName"),
      };
 
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestData),
      });
 
      const result = await response.json();
      // console.log("submitForApprovalERP response:", result);
 
      if (
        result.Status === "Success" &&
        result.Response &&
        result.Response.StatusName === "Success"
      ) {
        toast.success(
          result.Response.Message || "Submitted for Approval",
          {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          }
        );
        // setPopupVisible(false);
      } else {
        toast.warning(
          result.Response?.Message || "Failed to submit for approval",
          {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          }
        );
      }
    } catch (error) {
      console.error("Error in submitForApprovalERP API:", error);
      toast.error("Error in submitting for approval", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    }
  };

  useEffect(() => {
    const fetchRCone = async () => {
      try {
        // setLoading(true);
        const apiUrl = process.env.REACT_APP_API_URL;
        const requestData = {
            "Action": "getRCone",
            "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
            "CanId": "",
            "RConeId": "",
            "RCtwoId": "",
            "SubsubType": sessionStorage.getItem("subsubTypeId"),
        }
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        });
        const result = await response.json();
        // console.log("getRCone",result)
        if (result.Status === "Success") {
            setOptionResolutionCodeOne(result.data);
        }
        // else{
        //     toast.warning(result.ErrorDesc, {
        //         position: toast.POSITION.BOTTOM_CENTER,
        //         autoClose: 1500,
        //       });
        // }
        
      } catch (error) {
        console.error("Error fetching ETR reasons:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchRCone();
  }, []);

  const handleResolutionCodeOne = async (selectItem1) => {
    setResolutionCodeOne(selectItem1);
    
    // console.log("resolutionCodeOne.value",resolutionCodeOne)
    // console.log("selectItem1",selectItem1)
    try {
        // setLoading(true);
        const apiUrl = process.env.REACT_APP_API_URL;
        const requestData = {
            "Action": "getRCtwo",
            "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
            "CanId": "",
            "RConeId": selectItem1.value,
            "RCtwoId": "",
            "SubsubType": ""
        }
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        });
        const result = await response.json();
        // console.log("getRCtwo",result)
        if (result.Status === "Success") {
            setOptionResolutionCodeTwo(result.data)
        }
        
      } catch (error) {
        console.error("Error fetching ResolutionCodeOne:", error);
      } finally {
        setLoading(false);
      }
  };

  const handleResolutionCodeTwo = async (selectItem2) => {
     setResolutionCodeTwo(selectItem2);
    try {
        // setLoading(true);
        const apiUrl = process.env.REACT_APP_API_URL;
        const requestData = {
            "Action": "getRCthree",
            "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
            "CanId": "",
            "RConeId": "",
            "RCtwoId": selectItem2.value,
            "SubsubType": ""
        }
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        });
        const result = await response.json();
        // console.log("getRCthree",result)
        if (result.Status === "Success") {
            setOptionResolutionCodeThree(result.data)
        }
        
      } catch (error) {
        console.error("Error fetching ETR reasons:", error);
      } finally {
        setLoading(false);
      }
  };
  const handleResolutionCodeThree = (selectItem3) => {
    setResolutionCodeThree(selectItem3);
  };
  const handleCustomerContacted = (selectContact) => {
    setCustomerContacted(selectContact);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const apiUrl = process.env.REACT_APP_API_URL;
        const requestData = {
          Action: "getQuestBySrNo",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          QuesType: "FRE",
          SrNumber: sessionStorage.getItem("ViewSR"),
        };
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        });
        if (response.ok) {
          const result = await response.json();
          // console.log("API Response getQuestBySrNo:", result.Response);
          setCustomerFAQ(result.Response);
        } else {
          console.error("Error fetching data:", response.status);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);


  

  const handleUnifySession = async () => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const requestData = {
        "Action": "getCurrentSession",
        "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        "CanId": sessionStorage.getItem("CanId"),
        "RConeId": "",
        "RCtwoId": ""
      };
  
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });
        const result = await response.json();
        // console.log("API Response getCurrentSession:", result);
        const isUpAndRunning = result.response.bytesin > 0;
        setCurrentSessionStatus(isUpAndRunning ? 'Up & Running' : 'Not Working');
        
    } catch (error) {
      console.error("Error getting current session:", error);
    }
  };
  

  const navigate = useNavigate();
  const redirectAssignmentView = () => {
    navigate("/dashboard");
  };

  const handleIconClick = (formId) => {
    setActiveForm((prevActiveBox) =>
      prevActiveBox === formId ? null : formId
    );
  };

  const handleFileChangeWifi = async (event) => {
    const file = event.target.files[0];
    // Set compression options
    const options = {
      maxSizeMB: 1,            // Maximum file size in MB
      maxWidthOrHeight: 1920,  // Max width or height
      useWebWorker: true,      // Use web worker for faster compression
    };
      // Compress the image file
      const compressedFile = await imageCompression(file, options);
    const reader = new FileReader();
    reader.onload = (e) => {
      const base64String = e.target.result.split(";base64,")[1];
      // console.log("File content:", base64String); // Log base64 content
      const fileName = file.name;
      const fileExtension = fileName.split(".").pop(); // Extract file extension
      // console.log("File name:", fileName);
      // console.log("File extension:", fileExtension);
      setFileName(fileName); // Set the input text
      setFileExtensionWifi(fileExtension); // Set the file extension
      setBase64ContentWifi(base64String); // Set the base64 content
    };
    reader.readAsDataURL(compressedFile);
  };

  const handleFileChangeMl = async (event) => {
    const fileOne = event.target.files[0];
     // Set compression options
     const options = {
      maxSizeMB: 1,            // Maximum file size in MB
      maxWidthOrHeight: 1920,  // Max width or height
      useWebWorker: true,      // Use web worker for faster compression
    };
      // Compress the image file
      const compressedFile = await imageCompression(fileOne, options);
    const reader = new FileReader();
    reader.onload = (e) => {
      const base64String = e.target.result.split(";base64,")[1];
      // console.log("File content:", base64String); // Log base64 content
      const inputText = fileOne.name;
      const fileExtension = fileName.split(".").pop();
      // console.log("file name:", fileOne.name);
      setFileNameMl(inputText);
      setFileExtensionMl(fileExtension);
      setBase64ContentMl(base64String);
    };
    reader.readAsDataURL(compressedFile);
  };

  const handleFileChangeLan = async (event) => {
    const fileOne = event.target.files[0];
     // Set compression options
     const options = {
      maxSizeMB: 1,            // Maximum file size in MB
      maxWidthOrHeight: 1920,  // Max width or height
      useWebWorker: true,      // Use web worker for faster compression
    };
      // Compress the image file
      const compressedFile = await imageCompression(fileOne, options);
    const reader = new FileReader();
    reader.onload = (e) => {
      const base64String = e.target.result.split(";base64,")[1];
      // console.log("File content:", base64String); // Log base64 content
      const inputText = fileOne.name;
      const fileExtension = fileName.split(".").pop();
      // console.log("file name:", fileOne.name);
      setFileNameLan(inputText);
      setFileExtensionLan(fileExtension);
      setBase64ContentLan(base64String);
    };
    reader.readAsDataURL(compressedFile);
  };

  const handleFileChangeRouter = async (event) => {
    const fileOne = event.target.files[0];
    // Set compression options
    const options = {
      maxSizeMB: 1,            // Maximum file size in MB
      maxWidthOrHeight: 1920,  // Max width or height
      useWebWorker: true,      // Use web worker for faster compression
    };
      // Compress the image file
      const compressedFile = await imageCompression(fileOne, options);
    const reader = new FileReader();
    reader.onload = (e) => {
      const base64String = e.target.result.split(";base64,")[1];
      // console.log("File content:", base64String); // Log base64 content
      const inputText = fileOne.name;
      const fileExtension = fileName.split(".").pop();
      // console.log("file name:", fileOne.name);
      setFileNameRouter(inputText);
      setFileExtensionRouter(fileExtension);
      setBase64ContentRouter(base64String);
    };
    reader.readAsDataURL(compressedFile);
  };

  const openCamera = () => {
    document.getElementById("cameraFileInput").click();
  };
  const openCameraOne = () => {
    document.getElementById("cameraFileInputOne").click();
  };
  const openCameraTwo = () => {
    document.getElementById("cameraFileInputTwo").click();
  };
  const openCameraThree = () => {
    document.getElementById("cameraFileInputThree").click();
  };

  const popup = () => {
    Swal.fire({
      html: '<div style="font-size: 18px;">Attach File(s)*</div>',
      showCancelButton: true,

      confirmButtonText:
        '<span style="font-size: 15px;border-radius:10px;">Capture Live Picture or Documents*</span>',
      cancelButtonText: '<span style="font-size: 15px;">Cancel</span>',
      confirmButtonColor: "rgb(148,101,170)",
      //   cancelButtonColor: "white",
      customClass: {
        popup: "custom-popup",
        confirmButton: "custom-confirm-buttonYes",
        cancelButton: "custom-cancel-buttonNo",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        openCamera();
      } else {
        // openDocument();
        navigate("/materialConsumeNext");
      }
    });
  };
  const popupForMl = () => {
    Swal.fire({
      html: '<div style="font-size: 18px;">Attach File(s)*</div>',
      showCancelButton: true,

      confirmButtonText:
        '<span style="font-size: 15px;border-radius:10px;">Capture Live Picture or Documents*</span>',
      cancelButtonText: '<span style="font-size: 15px;">Cancel</span>',
      confirmButtonColor: "rgb(148,101,170)",
      //   cancelButtonColor: "white",
      customClass: {
        popup: "custom-popup",
        confirmButton: "custom-confirm-buttonYes",
        cancelButton: "custom-cancel-buttonNo",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        openCameraOne();
      } else {
        // openDocument();
        navigate("/materialConsumeNext");
      }
    });
  };
  const popupForLan = () => {
    Swal.fire({
      html: '<div style="font-size: 18px;">Attach File(s)*</div>',
      showCancelButton: true,

      confirmButtonText:
        '<span style="font-size: 15px;border-radius:10px;">Capture Live Picture or Documents*</span>',
      cancelButtonText: '<span style="font-size: 15px;">Cancel</span>',
      confirmButtonColor: "rgb(148,101,170)",
      //   cancelButtonColor: "white",
      customClass: {
        popup: "custom-popup",
        confirmButton: "custom-confirm-buttonYes",
        cancelButton: "custom-cancel-buttonNo",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        openCameraTwo();
      } else {
        // openDocument();
        navigate("/materialConsumeNext");
      }
    });
  };
  const popupForRouter = () => {
    Swal.fire({
      html: '<div style="font-size: 18px;">Attach File(s)*</div>',
      showCancelButton: true,

      confirmButtonText:
        '<span style="font-size: 15px;border-radius:10px;">Capture Live Picture or Documents*</span>',
      cancelButtonText: '<span style="font-size: 15px;">Cancel</span>',
      confirmButtonColor: "rgb(148,101,170)",
      //   cancelButtonColor: "white",
      customClass: {
        popup: "custom-popup",
        confirmButton: "custom-confirm-buttonYes",
        cancelButton: "custom-cancel-buttonNo",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        openCameraThree();
      } else {
        // openDocument();
        navigate("/materialConsumeNext");
      }
    });
  };

  const handleSaveArtifacts = async () => {
    try {
      setLoading(true);
      const apiUrl = process.env.REACT_APP_API_URL;
      const requestData = {
        Action: "saveAllArtifactsSR",
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        EmailId: sessionStorage.getItem("userName"),
        SrNumber: sessionStorage.getItem("ViewSR"),
        other_in_ml: base64ContentMl ? base64ContentMl : "",
        other_in_ml_extension: fileExtensionMl ? fileExtensionMl : "",
        router_position: base64ContentRouter ? base64ContentRouter : "",
        router_position_extension: fileExtensionRouter
          ? fileExtensionRouter
          : "",
        speed_on_lan: base64ContentLan ? base64ContentLan : "",
        speed_on_lan_extension: fileExtensionLan ? fileExtensionLan : "",
        speed_on_wifi: base64ContentWifi ? base64ContentWifi : "",
        speed_on_wifi_extension: fileExtensionWifi ? fileExtensionWifi : "",
      };

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });
      const result = await response.json();
      // console.log("API Response saveAllArtifactsSR:", result.Response);
      if (result.Status === 1) {
        toast.success("Upload Artifacts Successfully", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        navigate("/dashboard");
      }
    } catch (error) {
      console.error("Error saving artifacts:", error);
    }
    finally{
        setLoading(false);
    }
  };


  // const getLocation = () => {
  //   if ("geolocation" in navigator) {
  //     navigator.geolocation.getCurrentPosition(function (position) {
  //       setPosition({
  //         latitude: position.coords.latitude,
  //         longitude: position.coords.longitude,
  //       });
  //     });
  //   }
  // };

   const getLocation = () => {
          // Check if served over HTTPS (geolocation doesn't work over HTTP in production)
          if (window.location.protocol !== 'https:' && window.location.hostname !== 'localhost') {
              toast.error("Location access requires HTTPS. Please use a secure connection.", {
                  position: toast.POSITION.BOTTOM_CENTER,
                  autoClose: 2000,
              });
              return;
          }
  
          if ("geolocation" in navigator) {
              navigator.geolocation.getCurrentPosition(
                  (pos) => {
                      setPosition({
                          latitude: pos.coords.latitude,
                          longitude: pos.coords.longitude,
                          message: "Location Captured",
                      });
                  },
                  (error) => {
                      console.error("Geolocation error:", error);
                      toast.error("Unable to retrieve location. Please check browser permissions.", {
                          position: toast.POSITION.BOTTOM_CENTER,
                          autoClose: 2000,
                      });
                  }
              );
          } else {
              toast.warning("Geolocation is not supported by this browser.", {
                  position: toast.POSITION.BOTTOM_CENTER,
                  autoClose: 2000,
              });
          }
      };
  
      useEffect(() => {
          if (position.latitude && position.longitude) {
              // console.log("Updated position:", position);
          }
      }, [position]);

  useEffect(() => {
    getLocation();
  }, []);
// { console.log("userEmail",userName)}
// console.log("userEmail",sessionStorage.getItem("userEmail"))
const fetchWarehouseNumber = async () => {
  try {
    const resp = await fetch("https://ffamwapi.spectra.co/index.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        Action: "getWareHouseSRNumber",
        // srNumber: "SR25025005302",   // hardcoded for testing
        srNumber: sessionStorage.getItem("ViewSR")
      }),
    });

    const data = await resp.json();

    const wh = data?.Response?.WareHouseNumber;
    const nrg = data?.Response?.NRGPINNo;

    // Show popup ONLY if both values are present and non-empty
    if (typeof wh === "string" && wh.trim() !== "" &&
      typeof nrg === "string" && nrg.trim() !== "") {
      setWarehouseNumber(wh);
      setNrgPinNo(nrg);
      setShowWHModal(true);
    } else {
      // No popup – just fallback behaviour
      console.warn("Warehouse SR or NRGPINNo missing in response:", data);
      // optional:
      // toast.warn("Warehouse SR / NRGPIN not available");
      // navigate("/dashboard");
    }
  } catch (err) {
    console.error("Warehouse SR API error:", err);
    // optional:
    // toast.error("Failed to fetch Warehouse SR details");
    // navigate("/dashboard");
  }
};

const hadleSaveResolve = async () => {
  try {
    setLoading(true);

    const apiUrl = process.env.REACT_APP_API_URL;

    const requestData = {
      Action: "saveRCdetails",
      ActionCode: "",
      Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
      ContactNo: "",
      Contacted: "",
      CustomerID: sessionStorage.getItem("CanId"),
      CustomerName: "",
      ETR: "",
      ETRReason: "",
      EmailId: sessionStorage.getItem("userName"),
      EmpId: "",
      EngId: "",
      HoldReason: "",
      Latitude: `${position.latitude}`,
      Longitude: `${position.longitude}`,
      NetworkType: "GPON",
      RConeId: resolutionCodeOne?.value ? resolutionCodeOne.value : "",
      RCthirdId: resolutionCodeThree?.value ? resolutionCodeThree.value : "",
      RCtwoId: resolutionCodeTwo?.value ? resolutionCodeTwo.value : "",
      ReasonOf: userData?.rfo ? userData.rfo : "",
      ResolveContacted: customerContacted?.value ? customerContacted.value : "",
      SlotType: sessionStorage.getItem("slotType"),
      Source: "FFA App",
      srTypeTP: sessionStorage.getItem("SrTypeTP"),
      SrNumber: sessionStorage.getItem("ViewSR"),
      TaskType: "",
      UpdatedBy: "",
      resolvedByfromFFA: sessionStorage.getItem("userEmail"),
    };

    const response = await fetch(apiUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    const result = await response.json();

    // ✅ Only proceed when saveRCdetails is successful
    if (result.Status === 1) {
      // If DOA flow required, run that first
      if (doaFlag) {
        await handleSubmitApproval();
      }

      // ✅ Then hit Warehouse API
      await fetchWarehouseNumber();
      // Navigation to /dashboard is handled inside fetchWarehouseNumber:
      // - If both values exist -> show popup (OK button navigates)
      // - If missing or error -> navigate("/dashboard") directly
    } else {
      // Optional: handle failure case
      console.warn("saveRCdetails failed:", result);
      // toast.error("Failed to save RC details");
    }
  } catch (error) {
    console.error("Error saving saveRCdetails:", error);
    // toast.error("Error saving RC details");
  } finally {
    setLoading(false);
  }
};

  // const hadleSaveResolve = async ()=>{
  //   try {
  //       setLoading(true);
  //       const apiUrl = process.env.REACT_APP_API_URL;
  //       const requestData = {
  //           "Action": "saveRCdetails",
  //           "ActionCode": "",
  //           "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
  //           "ContactNo": "",
  //           "Contacted": "",
  //           "CustomerID": sessionStorage.getItem("CanId"),
  //           "CustomerName": "",
  //           "ETR": "",
  //           "ETRReason": "",
  //           "EmailId": sessionStorage.getItem("userName"),
  //           "EmpId": "",
  //           "EngId": "",
  //           "HoldReason": "",
  //           "Latitude": `${position.latitude}`,
  //           "Longitude": `${position.longitude}`,
  //           "NetworkType": "GPON",
  //           "RConeId": resolutionCodeOne.value  ? resolutionCodeOne.value : "",
  //           "RCthirdId": resolutionCodeThree.value  ? resolutionCodeThree.value : "",
  //           "RCtwoId": resolutionCodeTwo.value  ? resolutionCodeTwo.value : "",
  //           "ReasonOf": userData.rfo ? userData.rfo : "",
  //           "ResolveContacted": customerContacted.value ? customerContacted.value : "",
  //           "SlotType": sessionStorage.getItem("slotType"),
  //           "Source": "FFA App",
  //           "srTypeTP":  sessionStorage.getItem("SrTypeTP"),
  //           "SrNumber": sessionStorage.getItem("ViewSR"),
  //           "TaskType": "",
  //           "UpdatedBy": "",
  //           "resolvedByfromFFA" : sessionStorage.getItem("userEmail")
  //       };
       
       
  //       const response = await fetch(apiUrl, {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify(requestData),
  //       });
  //       const result = await response.json();
  //       // console.log("API Response saveRCdetails:", result.Response);
  //       if (result.Status === 1) {
  //         if (doaFlag) {
  //           await handleSubmitApproval();
  //         }

  //         navigate("/dashboard");
  //       }
  //     } catch (error) {
  //       console.error("Error saving saveRCdetails:", error);
  //     }
  //     finally{
  //         setLoading(false);
  //     }
  // }

  return (
    <>
      {/* ************************header*********************** */}
      <div className="container-fluid text-light Header-style header">
        <div className="p-3">
          <span
            className=""
            style={{ cursor: "pointer" }}
            onClick={redirectAssignmentView}
          >
            <i className="fa-solid fa-arrow-left-long"></i>
          </span>
          <span className="p-1 m-3">Resolution Consumption</span>
        </div>
      </div>
      {/* *************************header End*********************** */}
      {loading ? (
        <div className="loader-wrapper">
          <div className="loader">
            <img src={loader} alt="loading...."></img>
          </div>
        </div>
      ) : (
        <div className="container-fluid" style={{ marginTop: "65px" }}>
          <div className="container">
            <button
              type="submit"
              className="btn text-light w-100 add-item-btn mx-auto"
              onClick={handleUnifySession}
            >
              Get Unify Session
            </button>
            <div className="mt-1">
            <p className=" text-center currentSession-text">{currentSessionStatus}</p>
            </div>
          </div>

          <div
            className="contact-toggle"
            onClick={() => handleIconClick("form1")}
          >
            <span className="toggle-text">Resolution Consumption</span>
            <span className=" float-end">
              <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
            </span>
          </div>

          {activeForm === "form1" && (
            <div
              className=" container shadow mb-3 bg-body rounded mt-4"
              id="form1"
            >
              <form className="Person-Address-form p-3">
                <div className="search-area" style={{ position: "relative" }}>
                  <label className="select-search-label mt-2">RC 1 </label>
                  <Select
                    className="basic-single form-control form-control-sm p-1 custom-select"
                    classNamePrefix="select"
                    name="etrReason"
                    placeholder="Select Resolution Code 1"
                    styles={style}
                    isSearchable
                    value={resolutionCodeOne}
                    onChange={handleResolutionCodeOne}
                    options={optionResolutionCodeOne.map((data) => ({
                      value: data.rc_oneId,
                      label: `${data.rootCauseOne} (${data.rc_oneId})`,
                    }))}
                  />
                  <i
                    className="fas fa-search text-secondary"
                    style={{
                      position: "absolute",
                      right: "15px",
                      top: "63%",
                      transform: "translateY(-50%)",
                    }}
                  ></i>
                </div>

                <div className="">
                  <label className="select-search-label mt-2">RC 2</label>
                  <Select
                    className="basic-single form-control form-control-sm p-1 "
                    classNamePrefix="select"
                    name="etrReason"
                    placeholder="Select Resolution Code 2"
                    styles={style}
                    isSearchable={false}
                    value={resolutionCodeTwo}
                    onChange={handleResolutionCodeTwo}
                    options={optionResolutionCodeTwo.map((data) => ({
                      value: data.rc_twoId,
                      label: `${data.rootCauseTwo} (${data.rc_twoId})`,
                    }))}
                  />
                </div>

                <div className="">
                  <label className="select-search-label mt-2">RC 3</label>
                  <Select
                    className="basic-single form-control form-control-sm p-1 "
                    classNamePrefix="select"
                    name="etrReason"
                    placeholder="Select Resolution Code 3"
                    styles={style}
                    isSearchable={false}
                    value={resolutionCodeThree}
                    onChange={handleResolutionCodeThree}
                    options={optionResolutionCodeThree.map((data) => ({
                      value: data.rc_thirdId,
                      label: `${data.rootCauseThree} (${data.rc_thirdId})` ,
                    }))}
                  />
                </div>

                <div className="">
                  <label className="select-search-label mt-2">
                    Customer Contacted
                  </label>
                  <Select
                    className="basic-single form-control form-control-sm p-1 "
                    classNamePrefix="select"
                    name="etrReason"
                    placeholder="Select Item"
                    styles={style}
                    isSearchable={false}
                    value={customerContacted}
                    onChange={handleCustomerContacted}
                    options={optionCustomerContacted.map((data) => ({
                      value: data.value,
                      label: data.label,
                    }))}
                  />
                </div>

                <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="rfo"
                    name="rfo"
                    value={userData.rfo}
                    onChange={handleChange}
                  />
                  <label htmlFor="floatingInput" className="mt-2">
                    RFO
                  </label>
                </div>
              </form>
            </div>
          )}

          <div
            className="contact-toggle mt-2"
            onClick={() => handleIconClick("form2")}
          >
            <span className="toggle-text">FAQ</span>
            <span className=" float-end">
              <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
            </span>
          </div>

          {activeForm === "form2" && (
            <div
              className="container shadow mb-3 bg-body rounded mt-4"
              id="form2"
            >
              <form className="Person-Address-form p-3">
                {customerFAQ.map((item, index) => (
                  <div className="">
                    <label>
                      {item.quesId}. {item.question}
                    </label>
                    <div className="row mt-3">
                      <div className="col-md-4">
                        <input type="radio" name={`radio-${item.quesId}-yes`} className="radio-button" key={`radio-${item.quesId}-yes`}/>
                        &nbsp;&nbsp;
                        <span>Yes</span>
                      </div>
                      <div className="col-md-4">
                        <input type="radio" name={`radio-${item.quesId}-no`} className="radio-button" key={`radio-${item.quesId}-no`} />
                        &nbsp;&nbsp;
                        <span>No</span>
                      </div>
                      <div className="col-md-4">
                        <input type="radio" name={`radio-${item.quesId}-na`} className="radio-button" key={`radio-${item.quesId}-na`} />
                        &nbsp;&nbsp;
                        <span>Na</span>
                      </div>
                    </div>
                  </div>
                ))}

                
              </form>
              
            </div>
          )}

          <div
            className="contact-toggle mt-2"
            onClick={() => handleIconClick("form3")}
          >
            <span className="toggle-text">Upload Artifacts</span>
            <span className=" float-end">
              <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
            </span>
          </div>

          {activeForm === "form3" && (
            <div
              className="container shadow mb-3 bg-body rounded mt-4"
              id="form3"
            >
              <form className="Person-Address-form p-3">
                <div
                  className="input-box form-floating"
                  style={{ position: "relative" }}
                >
                  <input
                    id="cameraFileInput"
                    type="file"
                    // accept="image/*"
                    // capture="environment"
                    onChange={handleFileChangeWifi}
                    style={{ display: "none" }}
                  />
                  <input
                    type="text"
                    placeholder=""
                    className="form-control input-text form-control-sm mt-1"
                    id="picture"
                    name="picture"
                    value={fileName}
                    // accept="image/*"
                    // capture="environment"
                    style={{ background: "transparent" }}
                    onClick={popup}
                    readOnly
                  />
                  {/* <i
                    className="fa-solid fa-paperclip fa-paper-icon fa-locator"
                    onClick={popup}
                  ></i> */}
                  <label htmlFor="floatingInput" className="mt-2">
                    Speed on Wifi
                  </label>
                </div>

                <div
                  className="input-box form-floating"
                  style={{ position: "relative" }}
                >
                  <input
                    id="cameraFileInputOne"
                    type="file"
                    onChange={handleFileChangeMl}
                    style={{ display: "none" }}
                  />
                  <input
                    type="text"
                    placeholder=""
                    className="form-control input-text form-control-sm mt-1"
                    id="picture"
                    name="picture"
                    value={fileNameMl}
                    style={{ background: "transparent" }}
                    onClick={popupForMl}
                    readOnly
                  />
                  <label htmlFor="floatingInput" className="mt-2">
                    Other In ML
                  </label>
                </div>

                <div
                  className="input-box form-floating"
                  style={{ position: "relative" }}
                >
                  <input
                    id="cameraFileInputTwo"
                    type="file"
                    onChange={handleFileChangeLan}
                    style={{ display: "none" }}
                  />
                  <input
                    type="text"
                    placeholder=""
                    className="form-control input-text form-control-sm mt-1"
                    id="picture"
                    name="picture"
                    value={fileNameLan}
                    style={{ background: "transparent" }}
                    onClick={popupForLan}
                    readOnly
                  />
                  <label htmlFor="floatingInput" className="mt-2">
                    Speed on Lan
                  </label>
                </div>

                <div
                  className="input-box form-floating"
                  style={{ position: "relative" }}
                >
                  <input
                    id="cameraFileInputThree"
                    type="file"
                    onChange={handleFileChangeRouter}
                    style={{ display: "none" }}
                  />
                  <input
                    type="text"
                    placeholder=""
                    className="form-control input-text form-control-sm mt-1"
                    id="picture"
                    name="picture"
                    value={fileNameRouter}
                    style={{ background: "transparent" }}
                    onClick={popupForRouter}
                    readOnly
                  />
                  <label htmlFor="floatingInput" className="mt-2">
                    Router Position
                  </label>
                </div>
              </form>
            </div>
          )}

          <div className=" text-center mt-5 mb-2">
            <button
              type="submit"
              className="btn text-light etr-btn bg-dark mx-auto rounded-pill"
              onClick={handleSaveArtifacts}
            >
              Upload Artifacts
            </button>
          </div>

          <div className=" text-center mt-4 mb-5">
            <button
              type="submit"
              className="btn text-light etr-btn bg-dark mx-auto rounded-pill"
              onClick={hadleSaveResolve}
            >
              Submit Resolve
            </button>
          </div>
        </div>

      )}
      <Modal
        show={showWHModal}
        onHide={() => setShowWHModal(false)}
        centered
        backdrop="static"
        keyboard={true}
      >
        <Modal.Header closeButton style={{ backgroundColor: "#9465aa" }}>
          <Modal.Title style={{ color: "#ffffff" }}>
            Warehouse SR Created
          </Modal.Title>
        </Modal.Header>
 
        <Modal.Body>
          <div className="container-fluid">
            <div className="p-2">
              <h6 className="mb-2">Warehouse SR Number:</h6>
              <p style={{ fontSize: 18, fontWeight: 500 }}>{warehouseNumber}</p>
 
              <h6 className="mb-2 mt-3">NRGPIN No:</h6>
              <p style={{ fontSize: 16 }}>{nrgPinNo}</p>
            </div>
          </div>
        </Modal.Body>
 
        <Modal.Footer>
          <Button
            variant="outline-secondary"
            onClick={() => {
              const textToCopy = `Warehouse SR: ${warehouseNumber}\nNRGPIN No: ${nrgPinNo}`;
              navigator.clipboard
                ?.writeText(textToCopy)
                .then(() => {
                  // toast.success("Copied to clipboard");
                })
                .catch(() => {
                  // toast.warn("Copy failed");
                });
            }}
          >
            Copy
          </Button>
 
          <Button
            variant="primary"
            onClick={() => {
              setShowWHModal(false);
              navigate("/dashboard");
            }}
          >
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default MaterialConsumeNext;
